import { useCallback, useEffect, useState } from "react";
import { AiOutlineSearch } from "react-icons/ai";
import { Button, Col, Form, Row } from "reactstrap";
import SubjectFilter from "./SubjectFilter";
import "../../../../styles/filters.scss";
import CreatorsFilters from "./CreatorsFilters";
import DateFilters from "./DateFilters";
import ContentsFilter from "./ContentsFilter";
import CompanyFilters from "./CompanyFilter";

const Filters = (props: any) => {
  const { setFilters, setPage, filtersData } = props;
  const [reset, setReset] = useState(false);

  const handleNameChange = useCallback((event: any) => {
    setPage(1);
    setFilters((prev: any) => {
      return { ...prev, nom: event };
    });
  }, []);
  const handleSujetsChange = useCallback((subjects: any) => {
    setPage(1);
    setFilters((prev: any) => {
      return { ...prev, sujets: subjects };
    });
  }, []);
  const handleCreatorsChange = useCallback((creators: any) => {
    setPage(1);
    setFilters((prev: any) => {
      return { ...prev, createurs: creators };
    });
  }, []);
  const handleDatePubChange = useCallback((datePub: any) => {
    setPage(1);
    setFilters((prev: any) => {
      return { ...prev, datePub };
    });
  }, []);
  const handleDateTenuChange = useCallback((dateTenu: any) => {
    setPage(1);
    setFilters((prev: any) => {
      return { ...prev, dateTenu };
    });
  }, []);
  const handleContentChange = useCallback((content: any) => {
    setPage(1);
    setFilters((prev: any) => {
      return { ...prev, contenu: content };
    });
  }, []);
  const handleCompanyChange = useCallback((company: any) => {
    setPage(1);
    setFilters((prev: any) => {
      return { ...prev, entreprise: company };
    });
  }, []);

  const [name, setName] = useState<string>("");

  useEffect(() => {
    const delayDebounceFn = setTimeout(() => {
      handleNameChange(name);
    }, 1000);
    return () => clearTimeout(delayDebounceFn);
  }, [name, handleNameChange]);

  return (
    <Form>
      <Row>
        <Col lg="12">
          <AiOutlineSearch
            className="formSearchIcon"
            size={17}
            color="#bdbdbd"
          ></AiOutlineSearch>
          <input
            name="title"
            placeholder="Rechercher une formation"
            className="formControl label-search"
            onChange={(e) => setName(e.target.value.trim().toLowerCase())}
          />
        </Col>
      </Row>
      <Row className="my-3">
        <Col md="2">
          <SubjectFilter
            handleChange={handleSujetsChange}
            reset={reset}
          ></SubjectFilter>
        </Col>
        <Col md="2">
          <CreatorsFilters
            handleChange={handleCreatorsChange}
            reset={reset}
          ></CreatorsFilters>
        </Col>
        <Col md="2">
          <DateFilters
            handlePubChange={handleDatePubChange}
            handleTenuChange={handleDateTenuChange}
            reset={reset}
            setReset={setReset}
          ></DateFilters>
        </Col>
        <Col md="2">
          <ContentsFilter
            handleChange={handleContentChange}
            reset={reset}
          ></ContentsFilter>
        </Col>
        <Col md="2">
          <CompanyFilters
            handleChange={handleCompanyChange}
            reset={reset}
          ></CompanyFilters>
        </Col>
        <Col md="2">
          <Button
            className="btn-round-sm-secondary ms-2 validate mt-0"
            color="primary"
            onClick={() => {
              setReset(true);
              setFilters(filtersData);
              setPage(1);
            }}
          >
            Réinitialiser
          </Button>
        </Col>
      </Row>
    </Form>
  );
};

export default Filters;
